<template>
  <div class="sufee-login d-flex align-content-center flex-wrap">
    <div class="container">
      <div class="login-content">
        <!--<div class="login-logo">-->
        <!--<a href="index.html">-->
        <!--<img class="align-content" src="assets/logo.png" alt="">-->
        <!--</a>-->
        <!--</div>-->
        <h5>WebSelling</h5>
        <hr>
        <div class="login-form">
          <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>
          <!--<form>-->
          <div class="form-group">
            <label>{{$t('login.language')}}</label>
            <LngChooser :bgWhite="'true'"/>
          </div>

          <div class="form-group" v-if="canChooseCompany">
            <label>{{$t('login.strSearch')}}</label>
            <input @keyup="keymonitorSearch" v-model="strSearch" type="text" class="form-control" placeholder="" value="">
          </div>
          <div class="form-group" v-if="canChooseCompany && Array.isArray(companies)  && companies.length>0 ">
            <label>{{$t('login.companychoose')}}</label>
            <select id="id_store" class="form-control" v-model="data.company" name="id_store">
              <option v-for="company in companies" :value="company.id">{{company.text}}</option>
            </select>
          </div>
          <div class="form-group" v-if="!canChooseCompany">

            <!--<hr>-->
            <!--<label>{{$t('login.companychoose')}}</label>-->
            <!--<select id="id_store" class="form-control" v-model="data.company" name="id_store" r>-->
            <!--<option v-for="company in companies" :value="company.id">{{company.text}}</option>-->
            <!--</select>-->
            <!--<hr>-->

          </div>
          <template v-if="canLogin">

            <div class="form-group">
              <label>{{$t('login.user_name')}}</label>
              <input @keyup="keymonitorNext" v-model="data.user_name" type="text" class="form-control" placeholder="" value="">
            </div>
            <div class="form-group">
              <label>{{$t('login.password')}}</label>
              <input @keyup="keymonitor" v-model="data.user_password" type="password" class="form-control" placeholder="" value="">
            </div>
            <div class="checkbox">
              <!--<label>-->
              <!--<input type="checkbox"> Remember Me-->
              <!--</label>-->
              <label class="pull-right">
                <!--<router-link to="/forgottenpassword" tag="a" class="">{{$t('login.forgottenpassword')}}</router-link>-->
              </label>

            </div>
            <button v-on:click="login()" class="btn-login btn btn-success btn-flat m-b-30 m-t-30">{{$t('login.submit')}}</button>
          </template>
          <!--{{data}}-->
          <!--<div class="social-login-content">-->
          <!--<div class="social-button">-->
          <!--<button type="button" class="btn social facebook btn-flat btn-addon mb-3"><i class="ti-facebook"></i>Sign in with facebook</button>-->
          <!--<button type="button" class="btn social twitter btn-flat btn-addon mt-2"><i class="ti-twitter"></i>Sign in with twitter</button>-->
          <!--</div>-->
          <!--</div>-->
          <!--<div class="register-link m-t-15 text-center">-->
          <!--<p>Don't have account ? <a href="#"> Sign Up Here</a></p>-->
          <!--</div>-->
          <!--</form>-->
        </div>
      </div>
    </div>
  </div>


</template>


<script>
  import Api from '@/api/Api';
  import LngChooser from '@/components/LngChooser.vue';
  import AlertInPage from '@/components/AlertInPage.vue';
  import Helper from '@/helper/Helper';

  export default {
    name: 'Login',
    data() {
      return {
        data: {
          company: ""
          , user_name: ""
          , user_password: ""
        }
        , companies: []
        , canChooseCompany: false
        , strCompany: ""
        , wsid: ""
        , strSearch: ""
        , strSearchTimer: void 0
        , AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          delay: 5000,
        },
        canLogin: false,

      };
    },
    watch: {
      "data.company": function (newData, oldData) {
        const modul = this;
        if (newData) {
          modul.canLogin = true;

        }
      }
    },
    mounted() {
      const modul = this;
      modul.initsettings();

      this.$store.state.user = [];


      modul.$eventBus.$on('browserIdentifier', this.globalBrowserIdentifierHandler);
      modul.wsid = localStorage.getItem("browserIdentifier");

//      if (localStorage) {
//        modul.data.company = localStorage.getItem("company");
//      }
      modul.makeLoginCompanies();

      Api.logout({}).then(function (e) {
        if (e && e.result === true) {
          // logged out
        }
      });
    },
    beforeDestroy() {
      const modul = this;
      modul.$eventBus.$off('browserIdentifier');
    },
    methods: {
      initsettings(e){
        const modul = this;
        if (localStorage.getItem("invoiceUseType")) {
          modul.invoiceUseType = localStorage.getItem("invoiceUseType");
        } else {
          modul.invoiceUseType = "2";
          localStorage.setItem("invoiceUseType", modul.invoiceUseType);
        }

        let printQuestionInvoice = localStorage.getItem("printQuestionInvoice");
        if (printQuestionInvoice === null || printQuestionInvoice === void 0) {
          localStorage.setItem("printQuestionInvoice", true);
        }

      },
      keymonitorSearch(e){
        const modul = this;
        console.log(e);
        console.log(modul.strSearch);
        clearTimeout(modul.strSearchTimer);
        modul.makeLoginCompanies();
      },
      makeLoginCompanies(){
        const modul = this;
        modul.strSearchTimer = setTimeout(function () {
          Api.getLoginCompanies({wsid: modul.wsid, strSearch: modul.strSearch}).then(function (e) {
            console.log("getLoginCompanies-2")
            if (e && e.result === true) {
              modul.companies = e.companies;
              modul.canChooseCompany = true;
              if (e.company) {
                modul.canLogin = true;
                modul.data.company = e.company;
                modul.canChooseCompany = false;
              }
              modul.makeStrCompany()
            }
          });
        }, 1000)
      },
      makeStrCompany(){
        const modul = this;
        let strCompany = "";
        Array.prototype.forEach.call(modul.companies, function (e, x) {
          if (e.id === modul.data.company) {
            strCompany = e.text;
          }
        })
        modul.strCompany = strCompany;
      },
      globalBrowserIdentifierHandler(browserIdentifier){
        const modul = this;
        modul.wsid = browserIdentifier;
      },
      keymonitorNext(event){
        const modul = this;
        if (event.key === "Enter") {
          document.querySelector('[type="password"]').focus();
        }
      },
      keymonitor(event){
        const modul = this;
        if (event.key === "Enter") {
          modul.login();
        }
      },
      login(){
        const modul = this;
        console.log("login")
        modul.wsid = localStorage.getItem("browserIdentifier");

        if (localStorage && modul.wsid) {

        } else {
          modul.AlertInPage.msg = "login.identifiererror";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(5000));
          return
        }

        modul.$validator.validateAll().then((result) => {
          if (result) {
            const data = Helper.makeFilteredObjectByKeys(modul.data, ["company", "user_name", "user_password"]);
            data.wsid = localStorage.getItem("browserIdentifier");
            modul.AlertInPage.msg = "form.in_progress";
            modul.AlertInPage.type = "warning";
            console.log("Login data");
            console.log(data);
            Api.loginCreate(data).then(function (e) {
              console.log(e);
              if (e && e.result === true) {
                modul.$store.state.company = e.company;
                modul.$store.state.store = e.store;
                modul.$store.state.companyname = e.companyname;
                modul.$store.state.storename = e.storename;
                modul.$store.state.user = e.user;
                modul.$store.state.integrationconnection = e.integrationconnection;


//                localStorage.setItem("company", modul.data.company);
//                modul.company = e.company
//                if (modul.$store.state) {
//                  modul.$store.state.user = e.user;
//                }

                if (e && e.tokenSelling) {
                  localStorage.setItem('tokenSelling', e.tokenSelling);
                }
//                if (e && e.store) { //
//                  localStorage.setItem('store', e.store);
//                }
//                if (e && e.moduleRights) {
//                  modul.$store.state.moduleRights = e.moduleRights;
//                }

//                modul.$store.state.user = e.user;
                modul.AlertInPage.msg = "login.textsucces";
                modul.AlertInPage.type = "success";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
                  // Redirect
                  console.log("redirect Login");


                  modul.$router.push({name: "selectstore"})


                }, Number(1000));
              } else {
                modul.AlertInPage.msg = "login.texterror";
                modul.AlertInPage.type = "danger";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
                }, Number(5000));
              }
            }, function (e) {
              modul.AlertInPage.msg = "login.texterrorserver";
              modul.AlertInPage.type = "danger";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
              }, Number(5000));
            });

          } else {
            modul.AlertInPage.msg = "form.save_error";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(5000));
          }
        });
      }
    },
    components: {
      LngChooser
      , AlertInPage
    },
  };
</script>

